module.exports = __webpack_public_path__ + "static/media/cbre.90ec04cd.jpg";